import { Volume } from '@/api/type-server'
import { Radio, Trans } from '@/components'
import { useDomain } from '@/contexts/DomainContext'
import { useUserStore } from '@/stores/user'
import { formatDomain } from '@/utils/formatter'
import { cn } from '@/utils/style'
import { volumeUsage } from '@/utils/volume'

interface VolumeSelectorProps<T extends Volume = Volume> {
  values?: T[]
  value?: T
  machineDomains?: number[]
  getVolumeQuota: (volume: T) => number
  onChange: (value?: T) => void
}

export function VolumeSelector<T extends Volume = Volume>({
  values,
  value,
  machineDomains,
  getVolumeQuota,
  onChange,
}: VolumeSelectorProps<T>) {
  const { domainInfos, loading } = useDomain()
  const userStore = useUserStore()

  const getDomainName = (domain: number): string => {
    if (loading) return '...'
    return domainInfos.find((info) => info.domain === domain)?.displayName || formatDomain(domain)
  }

  return (
    <div>
      <h3 className="text-primary mb-4">
        <Trans i18nKey="create.volumeSelectorDataDrive">Datadrive</Trans>
      </h3>
      <table className="table mt-4">
        <thead>
          <tr>
            <th></th>
            {/* <th>
              <Trans i18nKey="create.volumeTableHeaderID">ID</Trans>
            </th> */}
            <th>
              <Trans i18nKey="create.volumeTableHeaderRegion">Region</Trans>
            </th>
            <th>
              <Trans i18nKey="create.volumeTableHeaderUsage">Usage</Trans>
            </th>
          </tr>
        </thead>
        <tbody>
          {values?.map((vol) => {
            const usage = volumeUsage(vol, userStore.isOrderExpired)
            return (
              <tr
                key={vol.id}
                className={cn('cursor-pointer', {
                  'bg-panel-gray-100': value?.id === vol.id,
                })}
                onClick={() => {
                  if (!machineDomains?.includes(vol.domain)) return
                  onChange(vol)
                }}
              >
                <td className="w-5 t-sm">
                  <Radio
                    checked={value?.id === vol.id}
                    onChange={() => onChange(vol)}
                    disabled={machineDomains?.includes(vol.domain) === false}
                  />
                </td>
                {/* <td>
                  <div className="text-primary t-sb">{vol.id}</div>
                </td> */}
                <td className="t-sm">
                  <div className="text-primary t-sb">{getDomainName(vol.domain)}</div>
                </td>
                <td className="t-sm">
                  <div className="text-primary t-sb flex">
                    {usage.usage}
                    <div className="text-tertiary">
                      /{getVolumeQuota(vol)}
                      {usage.unit}
                    </div>
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
